import React from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { connectProps } from 'store';
import { email } from 'model/component-props';

import logo from 'icons/logo.png';

import { styles } from './style';
//import { render } from 'react-dom';

class Header extends React.Component {


  logout = () => {
    window.sessionStorage.removeItem('userID');
    this.props.history.push('/login');
    this.props.logout();
  }

  render(){
    const { classes } = this.props;

  return (
    <div className={classes.root}>
      <AppBar className={classes.header} position="static">
        <Toolbar>
          <Link to={this.props.email === '' ? "/home" : '/collections'}><img src={logo} alt="logo"/></Link>
        </Toolbar>
        <button className={classes.logout} onClick={() => this.logout()}>{'LOGOUT'}</button>
      </AppBar>
    </div>
  );
}
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connectProps(email)(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./src/components/header/Header.js